import React, { useEffect, useState } from 'react';
import { apiGet } from '../api';

export default function ServiceDetailPage({ slug, locale = 'en' }) {
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const labels = locale === 'en'
    ? { heading: 'Service', back: 'Back', all: 'All Services', call: 'Call', email: 'Email', open: 'Open Link' }
    : { heading: 'സേവനം', back: 'പിന്നിലേക്ക്', all: 'എല്ലാ സേവനങ്ങളും', call: 'കോൾ', email: 'ഇമെയിൽ', open: 'ലിങ്ക് തുറക്കുക' };

  useEffect(() => {
    if (!slug) return;
    let ignore = false;
    const norm = (s) => (s || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)+/g, '');

    const staticServices = {
      en: [
        {
          title: 'Online Courses',
          description:
            'We offer interactive online courses covering various aspects of sustainable agriculture, including Purayidakrishi farming practices, organic farming principles, techniques, and crop-specific modules.',
          details:
            'Our comprehensive online learning platform includes PowerPoint presentations, expert lectures, and interactive assessments to enrich your learning experience.\n\nContact us for detailed information on course packages and schedules.',
        },
        {
          title: 'Classes/Workshops/Speeches',
          description:
            'We offer both in-person and virtual workshops, training sessions, and speaking engagements on sustainable farming practices.',
          details:
            'Tailored for farmers, government agencies, educational institutions, and agriculture enthusiasts, our programs include hands-on training and workshops in organic agriculture.\n\nContact us to schedule a session tailored to your needs.',
        },
        {
          title: 'Project Consultancy',
          description:
            'We provide professional consultancy services for agroecology-based projects, covering every stage from proposal development to implementation.',
          details:
            'Our services include:\n\n• Project proposal preparation – drafting clear, well-structured proposals.\n• Implementation strategies & monthly planning – designing practical, actionable roadmaps.\n• Individual consultancy – personalized guidance for your specific project needs.\n• Coordination & farm planning – strategic support to align activities with sustainable farm plans.\n\nWith our professional guidance, turn your ideas into practical, sustainable outcomes. Contact us to discuss your project requirements.',
        },
        {
          title: 'Organic Farm Educational Tours in Kerala',
          description:
            'We offer guided educational tours to our organic farm in Shoranur, along with visits to nearby organic farms. For those interested in exploring spice cultivation, we also arrange farm visits in the rural areas of Idukki District, which can be combined with refreshing forest treks.',
          details:
            'During these visits, you will gain hands-on learning experiences and practical demonstrations directly from experienced organic farmers.\n\nContact us to book your visit and get details on available tour packages and dates.',
        },
      ],
      ml: [
        { title: 'ഓൺലൈൻ കോഴ്സുകൾ', description: 'സുസ്ഥിര കൃഷി, ജൈവ കൃഷി രീതികൾ, കാർഷിക പരിസ്ഥിതി തത്വങ്ങൾ എന്നിവയുടെ വിവിധ വശങ്ങൾ ഉൾക്കൊള്ളുന്ന ഇന്ററാക്ടീവ് ഓൺലൈൻ കോഴ്സുകൾ.', details: 'വീഡിയോ ലെകചറുകൾ, ഡൗൺലോഡ് ചെയ്യാവുന്ന ഉറവിടങ്ങൾ, ഇന്ററാക്ടീവ് മൂല്യനിർണ്ണയങ്ങൾ എന്നിവയുള്ള സമഗ്ര ഓൺലൈൻ ലേണിംഗ് പ്ലാറ്റ്ഫോം.' },
        { title: 'ക്ലാസുകൾ/വർക്ക്ഷോപ്പുകൾ/പ്രഭാഷണങ്ങൾ', description: 'സുസ്ഥിര കൃഷി രീതികളെക്കുറിച്ചുള്ള ഇൻ-പേഴ്സണും വെർച്വലും ആയ വർക്ക്ഷോപ്പുകൾ, പരിശീലന ക്ലാസുകൾ, പ്രസംഗ ഇടപെടലുകൾ.', details: 'കർഷകർക്കും കാർഷിക താൽപ്പര്യമുള്ളവർക്കുമായുള്ള പ്രായോഗിക പരിശീലന സെഷനുകൾ, വിദ്യാഭ്യാസ വർക്ക്ഷോപ്പുകൾ, പ്രധാന പ്രഭാഷണങ്ങൾ.' },
        { title: 'പ്രോജക്ട് കൺസൾട്ടൻസി', description: 'കാർഷിക പ്രോജക്റ്റുകൾ, ഫാം പ്ലാനിംഗ്, സുസ്ഥിര വികസന സംരംഭങ്ങൾ എന്നിവയ്ക്കുള്ള പ്രൊഫഷണൽ കൺസൾട്ടേഷൻ സേവനങ്ങൾ.', details: 'പ്രോജക്റ്റ് പ്ലാനിംഗ്, നടപ്പാക്കൽ തന്ത്രങ്ങൾ, സുസ്ഥിര കാർഷിക വികസനം എന്നിവയിൽ വിദഗ്ധ മാർഗനിർദേശം.' },
        { title: 'ഞങ്ങളുടെ ഫാം സന്ദർശനങ്ങൾ', description: 'ശോരണൂരിലെ ഞങ്ങളുടെ ഫാമിന്റെ മാർഗനിർദേശമുള്ള വിദ്യാഭ്യാസ ടൂറുകൾ, പ്രായോഗിക പഠന അനുഭവങ്ങളോടെ.', details: 'സുസ്ഥിര കൃഷി രീതികൾ നേരിട്ട് അനുഭവിക്കാൻ നിങ്ങളുടെ സന്ദർശനം ബുക്ക് ചെയ്യുക. വിവിധ പാക്കേജുകളും തീയതികളും തിരഞ്ഞെടുക്കുക.' },
      ],
    };

    const aliases = {
      en: {
        'farm-visits': 'Organic Farm Educational Tours in Kerala',
      },
      ml: {},
    };

    const tryStaticFallback = () => {
      const list = staticServices[locale] || staticServices.en;
      const targetSlug = aliases[locale]?.[slug] ? norm(aliases[locale][slug]) : slug;
      const found = list.find((s) => norm(s.title) === targetSlug);
      if (found) {
        setService({ title: found.title, description: found.description, details: found.details, link: null });
        setError('');
        return true;
      }
      return false;
    };

    (async () => {
      try {
        setLoading(true);
        setError('');
        const data = await apiGet(`/api/services/${encodeURIComponent(slug)}`, { locale });
        if (!ignore) {
          if (data && !data.description && !data.details) {
            // Use static fallback copy when API has no descriptive content
            if (!tryStaticFallback()) setService(data);
          } else {
            setService(data || null);
          }
        }
      } catch (_) {
        if (!ignore) {
          if (!tryStaticFallback()) setError('Not found');
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, [slug, locale]);

  return (
    <section className="services" style={{ paddingTop: '24vh' }}>
      <div className="container">
        <div className="services-header">
          <h2>{service?.title || (loading ? 'Loading…' : labels.heading)}</h2>
          {service?.description && <p>{service.description}</p>}
        </div>

        {error && <div style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</div>}

        {service && (
          <article className="card">
            {service.details && (
              <div className="service-details" style={{ whiteSpace: 'pre-line' }}>{service.details}</div>
            )}
            <div className="service-actions" style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
              {service.phone && (
                <a className="service-btn" href={`tel:${String(service.phone).replace(/\s+/g,'')}`}>
                  {labels.call}
                </a>
              )}
              {service.email && (
                <a className="service-btn" href={`mailto:${service.email}`}>
                  {labels.email}
                </a>
              )}
            </div>
          </article>
        )}

        <div className="english-blog-footer" style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
          <button className="english-view-all-posts" onClick={() => { window.history.length > 1 ? window.history.back() : (window.location.hash = '#'); }}>{labels.back}</button>
          <button className="english-view-all-posts" onClick={() => { window.location.hash = '#'; }}>{labels.all}</button>
        </div>
      </div>
    </section>
  );
}
